export default __webpack_public_path__ + "giveaway-locales/de-DE.487d08f11f574f119fa50503d5baec71.json";